import Component from '../core/Component'
import Cleave from 'cleave.js'

const defaultCleaveOptions = {
    date: true,
    dateMin: '1900-01-01',
    dateMax: '2100-01-01',
    delimiter: '.',
    datePattern: ['d', 'm', 'Y']
}

export default class InputDateWithPicker extends Component {
    constructor(element, options) {
        super(element, options = {})
    }

    prepare() {
        new Cleave(this.element, {
            ...defaultCleaveOptions,
            ...this.options
        })
    }
}